<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Meus espelhos de ponto</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-striped table-bordered">
              <thead>
                <th scope="col">Período</th>
                <th scope="col">Início Período</th>
                <th scope="col">Fim Período</th>
                <th scope="col">Jornada</th>
                <th scope="col">Feriados no Período</th>
                <th scope="col">Dias Úteis</th>
                <th scope="col">Total à Trabalhar</th>
                <th scope="col">Total Trabalhado</th>
                <th scope="col">Banco de Horas no Período</th>
                <th scope="col">Ações</th>
              </thead>
              <tbody>
                <tr v-for="mirror in mirrors" :key="mirror.id">
                  <td>
                    {{ mirror.period_f }}
                  </td>
                  <td>{{ mirror.start_period }}</td>
                  <td>{{ mirror.end_period }}</td>
                  <td>{{ mirror.journey.title }}</td>
                  <td>{{ mirror.holidays }}</td>
                  <td>{{ mirror.usefull_days }}</td>
                  <td>{{ mirror.total_working }}</td>
                  <td>{{ mirror.total_worked }}</td>
                  <td>{{ mirror.bank_of_hours }}</td>
                  <td>
                    <a
                      :href="downloadMirror(mirror.id)"
                      target="_blank"
                      class="btn btn-crud edit"
                      ><i class="fas fa-download"></i
                    ></a>
                  </td>
                </tr>
                <tr>
                  <td v-if="mirrors.length == 0" colspan="9" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mirrors: [],
    };
  },
  computed: {},
  methods: {
    downloadMirror: function (id) {
      return (
        this.$store.state.url +
        "/export/point_mirror/" +
        id +
        "/Innov@AR3PointMirror2120INnv"
      );
    },
    getEntity: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "point-mirror/my";

      self.$http
        .post(api)
        .then((response) => {
          self.mirrors = response.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getEntity();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PointMirror/My.vue